import { render, staticRenderFns } from "./shareActive.vue?vue&type=template&id=fb089ff8&scoped=true"
import script from "./shareActive.vue?vue&type=script&lang=js"
export * from "./shareActive.vue?vue&type=script&lang=js"
import style0 from "./shareActive.vue?vue&type=style&index=0&id=fb089ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb089ff8",
  null
  
)

export default component.exports